module.exports = __webpack_public_path__ + "img/fromages.8b61cbdd.svg";